export default "__VITE_ASSET__4e50ab13__"